<template>
	<a
		class="js-scroll-top md:hidden fixed bottom-14 right-4 z-30 flex flex-col items-center justify-center gap-1.5 w-14 h-14 bg-dark rounded-full shadow-lg border-[3px] border-solid border-light transition-opacity delay-200"
		:class="{ 'opacity-0': inactive, '-right-20': inactive, 'opacity-100': !inactive }"
		@click.prevent="scrollToTop()"
		href="#"
	>
		<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M7.70234 0.304093L13.6957 6.2924C14.1014 6.66667 14.1014 7.32164 13.6957 7.69591C13.3211 8.10136 12.6656 8.10136 12.291 7.69591L6.98439 2.42495L1.70903 7.69591C1.33445 8.10136 0.67893 8.10136 0.304348 7.69591C-0.101449 7.32164 -0.101449 6.66667 0.304348 6.2924L6.29766 0.304093C6.67224 -0.101365 7.32776 -0.101365 7.70234 0.304093Z" fill="#F4F1EB"/>
		</svg>

		<span class="text-[9px] leading-none font-regular text-light text-center">BACK TO TOP</span>
	</a>
</template>
<script>
export default {
	data: () => ({
		inactive: true,
		lastScrollTop: 0,
	}),
	methods: {
		toggleScrollToTopButton() {
			let scrolled = window.scrollY;
			let scroll_position = window.pageYOffset || document.documentElement.scrollTop;

			if( scrolled > 1000 && scroll_position < this.lastScrollTop ) {
				this.inactive = false;
			} else {
				this.inactive = true;
			}

			this.lastScrollTop = scroll_position <= 0 ? 0 : scroll_position;
		},
		scrollToTop() {
			window.scroll({top: 0, behavior: "smooth"});
		},
	},
	created() {
		document.addEventListener("scroll", () => {
			this.toggleScrollToTopButton()
		})
	},
}
</script>